export const paymentAmounsList = ["$ 100", "$ 200", "$ 500", "$ 1000", "Full"];
